import { render, staticRenderFns } from "./ProfileVideos.vue?vue&type=template&id=0935dca4&"
import script from "./ProfileVideos.vue?vue&type=script&lang=js&"
export * from "./ProfileVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports